import { defineMessages } from "react-intl";

const PREFIX = "ArgicultureWidget";
export default defineMessages({
  headerLabel: {
    id: `${PREFIX}.header.label`,
    defaultMessage: "What's new in Argicilture Terminal?",
  },
  headerMore: {
    id: `${PREFIX}.header.more`,
    defaultMessage: "More news",
  },
});
